import { isNewerPrSnapshot, prStateFromGitHub, type PrStateSnapshot } from '@reflex/shared';
import type { PullRequestDetails } from './useGitHubRepos.js';

/** The versioned state a set of live PR details reads as. */
export function prSnapshotFromDetails(details: PullRequestDetails): PrStateSnapshot {
  return { state: prStateFromGitHub(details), updatedAt: details.updatedAt };
}

/**
 * Whether `incoming` details should replace `current` ones: webhook pushes and
 * fetches race and arrive out of order, so an older row must not overwrite a
 * newer one (a merged PR flipping back to open). See `isNewerPrSnapshot`.
 */
export function isNewerPullRequestDetails(
  incoming: PullRequestDetails,
  current: PullRequestDetails | undefined,
): boolean {
  return isNewerPrSnapshot(
    prSnapshotFromDetails(incoming),
    current ? prSnapshotFromDetails(current) : null,
  );
}
